<style>
    .diia-button-style {
        background-color: #000 !important;
        border-radius: 20px !important;
        color: #fff !important;
        padding: 12px 28px !important;
        font-size: 13px;
        font-weight: normal !important;
        line-height: 1 !important;
    }

    .diia-filter-button-style {
        border: 2px #bbb solid; 
        border-radius: 20px;
        font-size: 13px !important;
        font-weight: normal !important;
        line-height: 1 !important;
    }

    .diia-filter-button-style:hover {
        background-color: #fff !important;
    }

    .theme--light.v-btn:focus::before, .theme--light.v-btn--active::before, .theme--light.v-btn:hover::before, .theme--light.v-btn--active:focus::before {
        background-color: transparent !important;
        opacity: 0 !important;
    }


    .lower-text > .v-input__control > .v-input__slot > .v-select__slot > .v-label {
        font-size: 13px! important;
    }

    v-checkbox > * {
        color: black !important;
    }

    .filter-expansion-panels > .v-expansion-panel::before {
        box-shadow: none !important;
    }

    .filter-expansion-panels > .v-expansion-panel:not(:first-child)::after {
        border-top: 0px;
    }

    .filter-expansion-panels > .v-expansion-panel--active > .v-expansion-panel-header {
        min-height: inherit !important;
        border-bottom: 0px;
    }

    .filter-expansion-panels > .v-expansion-panel--active > .v-expansion-panel-content {
        border-bottom: 1px solid black !important;
    }

    .filter-expansion-panels > .side-help-menu-expansion-panel:first-child > .side-help-menu-expansion-panel-header {
        border-top: 1px solid black !important;
    }

    .filter-expansion-panel {
        padding-bottom: 20px;
        border-radius: 0px !important;
        background-color: transparent !important;
    }

    .filter-expansion-panel-header {
        padding: 8px 0px 18px 0px;
        font-size: 18px;
        line-height: 24px;
        border-top: 0px !important;
        border-bottom: 2px solid black;
    }

    .filter-expansion-panel-content > .v-expansion-panel-content__wrap {
        padding: 0px;
    }

    .filter-expansion-panels > .v-expansion-panel--active:not(:first-child), .v-expansion-panel--active + .v-expansion-panel {
        margin-top: 0px !important;
    }

    .filter-list-item-title {
        line-height: 24px; 
        font-size: 14px !important;
        font-weight: 300px;
    }

    .v-autocomplete .v-select__selections {
        word-break: break-all !important;
    }

    .list-filter-autocomplete-item {
        padding: 10px;
        width: 100%;
    }
    .list-filter-autocomplete-item:hover {
        background-color: #E7EEF3;
    }
</style>
<!-- .v-text-field > .v-input__control > .v-input__slot:before {
    border-image: linear-gradient(90deg, #2833d0 0, #7179ef 17.19%, #bf98c6 48.44%, #f1acac 100%) !important;
}
-->
<template>
    <v-card elevation="0" class="pa-0 ma-0 pt-2">
            <v-card-text class="pa-0 ma-0" :key="key_render">
                    <!-- <v-expansion-panels class="filter-expansion-panels" multiple>
                            <v-expansion-panel class="filter-expansion-panel" v-for="[setting_index, setting] of filters.entries()" :key="setting.name">
                                <v-expansion-panel-header class="filter-expansion-panel-header">
                                    <div class="mt-0">{{ setting.name }}</div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="filter-expansion-panel-content"> -->
                                    <span style="font-size: 18px; font-weight: bold;">Поля:</span>
                                    <v-list dense class="mt-4">
                                        <v-list-item-group color="primary">
                                            <draggable @change="updateHeadersOrder" v-model="available_headers_list" item-key="name" group="people" @start="drag=true" @end="drag=false">
                                                <v-checkbox class="ma-0" color="black" v-for="item in available_headers_list" :key="item + item" @change="multiselectCheckboxChanged($event, item)" v-model="selected_headers[item.value]" :off-icon="'mdi-checkbox-blank-outline'" :on-icon="'mdi-checkbox-outline'" :ripple="false" :label="item.text"></v-checkbox>
                                            </draggable>
                                        </v-list-item-group>
                                    </v-list>

                                    <span style="font-size: 18px; font-weight: bold; margin-bottom: 15px;">Додаткові налаштування:</span>
                                    <v-checkbox class="ma-0" color="black" @change="copyModeSwitched" :off-icon="'mdi-checkbox-blank-outline'" :on-icon="'mdi-checkbox-outline'" :ripple="false" label="Режим копіювання"></v-checkbox>
                                    
                                <!-- </v-expansion-panel-content>
                            </v-expansion-panel>
                    </v-expansion-panels> -->
            </v-card-text>

            <!-- <v-card-actions class="justify-end pr-0">
                <v-row class="ma-0 pa-0 flex-column flex-sm-row justify-end">
                    <v-btn 
                        class="mb-1 mt-1 diia-button-style"
                        color="black"
                        elevation="0"
                        style="letter-spacing: normal; text-transform: none;"
                        @click="clearFilters"
                    >   
                        Скинути налаштування
                    </v-btn>
                    <v-btn 
                        class="mb-1 mt-1 ml-0 ml-sm-3 diia-button-style"
                        color="black"
                        elevation="0"
                        style="letter-spacing: normal; text-transform: none;"
                        @click="exportToExcel"
                    >   
                        Excel <v-icon style="font-size: 16px; color: white; margin-left: 10px;">mdi-download</v-icon>
                    </v-btn>
                    <v-btn 
                        class="mb-1 mt-1 ml-0 ml-sm-3 diia-button-style"
                        color="black"
                        elevation="0"
                        style="letter-spacing: normal; text-transform: none;"
                        @click="exportToCSV"
                    >   
                        CSV <v-icon style="font-size: 16px; color: white; margin-left: 10px;">mdi-download</v-icon>
                    </v-btn>
                </v-row>
            </v-card-actions> -->
        </v-card>
</template>


<script>
/* eslint-disable */
import clib from "../js/common_lib"
import axios from "axios";

import draggable from 'vuedraggable'

export default {
  name: "ListHeadersModifier",
  components: {draggable,},
  props: ['object_type', 'list_data'],
  data: () => ({
    available_headers_list: [],

    object_headers_localstorage_name: "",
    object_headers_order_localstorage_name: "",

    selected_headers: {},
    selectedItem: "",
    dialog: false,
    filters: [],
    key_render: 1,
    filters_values: {},
    selected_filters_values: {},
    form_v_model: [],

    initial_query_params: null,
  }),
    created: function () {
        // console.log("MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
        // console.log(this.$config.configuration.organization.list.items.filter(obj => localStorage.getItem('organization_list_headers').split(',').includes(obj.value)));
        // this.$config.configuration.organization.list.items;

        if (this.object_type == "organization") {
            this.object_headers_localstorage_name = "organization_list_headers";
            this.object_headers_order_localstorage_name = "organization_list_order";
            this.available_headers_list = structuredClone(this.$config.configuration.organization.list.items);
        }
        else if (this.object_type == "information_resource") {
            this.object_headers_localstorage_name = "eresource_list_headers";
            this.object_headers_order_localstorage_name = "eresource_list_order";
            this.available_headers_list = structuredClone(this.$config.configuration.information_resource.list.items);
        }
        else if (this.object_type == "subsystem") {
            this.object_headers_localstorage_name = "subsystem_list_headers";
            this.object_headers_order_localstorage_name = "subsystem_list_order";
            this.available_headers_list = structuredClone(this.$config.configuration.subsystem.list.items);
        }
        else if (this.object_type == "interface") {
            this.object_headers_localstorage_name = "interface_list_headers";
            this.object_headers_order_localstorage_name = "interface_list_order";
            this.available_headers_list = this.$config.configuration.information_resource_interface.list.items;
        }
        else if (this.object_type == "service") {
            this.object_headers_localstorage_name = "service_list_headers";
            this.object_headers_order_localstorage_name = "service_list_order";
            this.available_headers_list = this.$config.configuration.service.list.items;
        }
        else if (this.object_type == "interaction") {
            this.object_headers_localstorage_name = "interaction_list_headers";
            this.object_headers_order_localstorage_name = "interaction_list_order";
            this.available_headers_list = this.$config.configuration.interaction.list.items;
        }
        else if (this.object_type == "server") {
            this.object_headers_localstorage_name = "server_list_headers";
            this.object_headers_order_localstorage_name = "server_list_order";
            this.available_headers_list = this.$config.configuration.server.list.items;
        }

        for (const item of this.available_headers_list) {
            if (localStorage.getItem(this.object_headers_localstorage_name).split(',').includes(item.value))
                this.selected_headers[item.value] = true;
            else
                this.selected_headers[item.value] = false;
        }
    },
    computed: {
        dateRangeText () {
            return this.dates.join(' ~ ')
        },
    },

    methods: {
        exportToExcel() {
            this.$emit('on-export-to-excel');
        },
        exportToCSV() {
            this.$emit('on-export-to-csv');
        },

        copyModeSwitched(event) {
            console.log(event);
            this.$emit('copy-mode-switch', event);
        },

        updateHeadersOrder() {
            const dataValues = this.available_headers_list.map(item => item.value).join(',');
            
            localStorage.setItem(this.object_headers_order_localstorage_name, dataValues);

            this.$emit('on-headers-update');
        },

        multiselectCheckboxChanged(new_value, selected_item) {
            let new_headers_selected = Object.keys(this.selected_headers).filter(key => this.selected_headers[key]);

            localStorage.setItem(this.object_headers_localstorage_name, new_headers_selected.join(','));
            
            this.$emit('on-headers-update');
        },

        multiselectsearchChanged(new_value, filter_code) {
            this.selected_filters_values[filter_code] = new_value;
        },
        daterangeChanged(new_value, filter_code) {
            this.selected_filters_values[filter_code] = new_value;
        },
        clearDaterange(filter_code, filter_index) {
            this.form_v_model[filter_index] = [];
            this.selected_filters_values[filter_code] = [];
        },
        applyFilters() {
            this.$config.filter_params[this.object_type] = {};

            for (let filter_values in this.selected_filters_values) {
                if (this.selected_filters_values[filter_values] && this.selected_filters_values[filter_values].length > 0) {
                    this.$config.filter_params[this.object_type][filter_values] = this.selected_filters_values[filter_values].join(',');
                }
            }

            let selected_filters_verbose = [];

            for (let filter_values in this.selected_filters_values) {
                if (this.selected_filters_values[filter_values] && this.selected_filters_values[filter_values].length > 0) {
                    let current_filter = this.filters.find(function (x) {
                        return x.code == filter_values;
                    });

                    let array_values = [];

                    if (current_filter.type == "multiselect") {
                        for (let j in this.selected_filters_values[filter_values]) {
                            let eng = this.selected_filters_values[filter_values][j];
                            array_values.push(this.filters_values[filter_values][eng]);
                        }

                        selected_filters_verbose.push({
                            'name': current_filter.name,
                            'uuid': clib.uuidv4(),
                            'value': array_values.join(',')
                        });
                    }

                    if (current_filter.type == "daterange") {
                        selected_filters_verbose.push({
                            'name': current_filter.name,
                            'uuid': clib.uuidv4(),
                            'value': this.selected_filters_values[filter_values].join(',')
                        });
                    }

                    if (current_filter.type == "multiselectsearch") {
                        for (let object_item in this.selected_filters_values[filter_values]) {
                            let object_key = this.selected_filters_values[filter_values][object_item];
                            let obj = this.filters_values[filter_values].find(function (x) {
                                return x.key == object_key;
                            });
                            
                            if (obj)
                                array_values.push(obj.value);
                        }

                        selected_filters_verbose.push({
                            'name': current_filter.name,
                            'uuid': clib.uuidv4(),
                            'value': array_values.join(',')
                        });
                    }
                }
            }

            this.$emit('on-filters-apply', this.object_type, selected_filters_verbose);
        },
        clearFilters() {
            this.$emit('on-filters-clear', this.object_type);
        },
        async fetchAllFilters() {
            for (let filter in this.filters) {
                if (this.filters[filter].values_source == 'external') {
                    await this.fetchFilterValues(this.filters[filter].code, this.$config.backend_url + this.filters[filter].endpoint + '&env=' + this.$config.query_params.env);
                }

                if (this.initial_query_params) {
                    let query_value = this.initial_query_params[this.filters[filter].code];
                    if (query_value) {
                        this.selected_filters_values[this.filters[filter].code] = query_value.split(',');
                    } else {
                        this.selected_filters_values[this.filters[filter].code] = [];
                    }
                } else {
                    this.selected_filters_values[this.filters[filter].code] = [];
                }
            }

            if (this.initial_query_params) {
                this.applyFilters();
            }

            this.key_render += 1;
        },
        async fetchFilterValues(code, url) {
            return axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.filters_values[code] = response.data;
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
        }
    }
}
</script>